export const stripTrailingSlash = (str?: string) => {
  if (!str) return "";

  if (str[str.length - 1] === "/") {
    return str.substring(0, str.length - 1);
  }
  return str;
};
